import {defineStore} from 'pinia'
import {UserData} from '../interfaces/user'
import {clientService} from '../services/client';

export const useUserStore = defineStore('user', {
    state: () => {
        if (localStorage.getItem("lsUser"))
            return JSON.parse(localStorage.getItem("lsUser") as string);

        return {
            user: null as UserData | null,
            logged_in: false,
            token: null as string | null,
        }
    },
    actions: {
        logout() {
            // localStorage.removeItem("lsUser");
            localStorage.clear();

            this.user = null;
            this.logged_in = false;
            this.token = null;
        },

        update(user: UserData) {
            return clientService.update(user);
        },
        updateEmergency(user: UserData) {
            return clientService.updateEmergency(user);
        },
        updatePrimary(user: UserData) {
            return clientService.updatePrimary(user);
        },
        updateShipping(user: UserData) {
            return clientService.updateShipping(user);
        },
        updateGpDetails(user: UserData) {
            return clientService.updateGpDetails(user);
        },
        updateInsuranceDetails(user: UserData) {
            return clientService.updateInsuranceDetails(user);
        },

        setUser(user: UserData, clinicAvatar = {}) {
            this.user = {...user, ...clinicAvatar};
        }
    }
});